/** Типы ответов API, общие для сервера и мини-приложения. */
import type { Role } from './roles.ts';

export interface ChildDto {
  id: string;
  familyId: string;
  name: string;
  birthDate: string;
  sex: 'male' | 'female' | null;
  birthWeightG: number | null;
  feeding: 'breast' | 'formula' | 'mixed' | null;
  /** Подписанная ссылка на фото или null. */
  photoUrl: string | null;
}

export interface FamilyDto {
  id: string;
  name: string;
  tz: string;
  role: Role;
  children: ChildDto[];
  settings: FamilySettings;
}

/** Справочники семьи (их можно править в настройках). */
export interface FamilySettings {
  sleepPlaces?: string[];
  sleepClothes?: string[];
  sleepPositions?: string[];
  sleepMethods?: string[];
}

/** Личные настройки пользователя. */
export interface UserSettings {
  /** Порядок кнопок действий на «Сегодня»; скрытые — в hidden. */
  actions?: string[];
  hiddenActions?: string[];
}

export const DEFAULT_SLEEP_PLACES = ['Кроватка', 'Коляска', 'На руках', 'С родителями', 'Автокресло', 'Слинг'];
export const DEFAULT_SLEEP_CLOTHES = ['Боди', 'Слип', 'Пелёнка', 'Спальный мешок', 'Только подгузник', 'Шапочка', 'Носочки'];
export const DEFAULT_SLEEP_POSITIONS = ['На спине', 'На левом боку', 'На правом боку', 'На животе'];
export const DEFAULT_SLEEP_METHODS = ['Укачивание', 'На руках', 'Грудь', 'Бутылочка', 'Соска', 'Белый шум', 'Колыбельная', 'Поглаживание', 'В коляске', 'Сам уснул'];

export interface MeDto {
  user: { id: number; firstName: string; username: string | null; settings: UserSettings };
  families: FamilyDto[];
}

export interface MemberDto {
  userId: number;
  name: string;
  role: Role;
  isMe: boolean;
}

export interface ReminderSettingsDto {
  feedIntervalMin: number | null;
  eveningSummary: boolean;
  eveningAt: string;
  quietFrom: string | null;
  quietTo: string | null;
}
